import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import pptxgen from "pptxgenjs";
import { ExportService } from 'src/app/services/export.service';
import { MessageService, ConfirmationService, ConfirmEventType } from 'primeng/api';

@Component({
  selector: 'app-announcement-results',
  templateUrl: './announcement-results.component.html',
  styleUrl: './announcement-results.component.scss'
})
export class AnnouncementResultsComponent {


  announcementId: string = '';
  announcement: any;
  header = this.translate('Announcement Results');
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: ``,
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Announcements'), link: `/announcement` },
    { name: this.translate('Announcement Results'), link: `/announcement/results/` },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  messages: any[] = [];
  skelition: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private exportService: ExportService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.skelition = true;
    this.route.params.subscribe(params => {
      this.announcementId = params['Id'];
      this.breadcrumbs[1] = {
        name: this.translate('Announcement Results'),
        link: `/announcement/results/` + this.announcementId,
      };
      this.fetchMainData().then(() => {
        this.header = this.announcement.title;
        this.skelition = false;
      });
    });
  }

  async fetchMainData() {
    try {
      let res = await this.dataService.getData('announcement/getResults/' + this.announcementId);
      if (res.error) {
        return;
      }
      this.announcement = res.data;
      console.log("this.announcement",this.announcement);
    } catch (e) {
      console.log("error", e)
    }
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  openAssessmentPage(announcement: any) {
    this.router.navigate(
      ['/assessment/results/', announcement.assessmentId], 
      { queryParams: { QBankId: announcement.questionBankId, tabIndex: 0 } }
    );
  }

}
